{
    "swashbuckler": {
        "key": "swashbuckler",
        "isDead": false,
        "position": {
            "x": 13,
            "y": 29,
            "z": 1
        },
        "effects": {},
        "inventory": {
            "items": {}
        }
    },
    "squire": {
        "key": "squire",
        "isDead": false,
        "position": {
            "x": 20,
            "y": 31,
            "z": 1
        },
        "affiliation": "blue",
        "jobKey": "pirates/swordknight",
        "power": 10,
        "maxhealth": "30",
        "imageKey": "knight",
        "portraitKey": "knight-grunt",
        "effects": {},
        "inventory": {
            "items": {}
        },
        "title": "Squire",
        "subtitle": "Soldier of the King"
    },
    "mRVu6": {
        "key": "mRVu6",
        "isDead": false,
        "position": {
            "x": 21,
            "y": 27,
            "z": 1
        },
        "affiliation": "blue",
        "jobKey": "pirates/hammerknight",
        "power": 10,
        "maxhealth": "30",
        "imageKey": "knight",
        "portraitKey": "knight-grunt",
        "effects": {},
        "inventory": {
            "items": {}
        },
        "title": "Knight",
        "subtitle": "Soldier of the King"
    },
    "P4-ds": {
        "key": "P4-ds",
        "isDead": false,
        "position": {
            "x": 27,
            "y": 14,
            "z": 1
        },
        "affiliation": "blue",
        "jobKey": "pirates/spear",
        "maxhealth": 30,
        "imageKey": "knight",
        "portraitKey": "knight-grunt",
        "effects": {},
        "inventory": {
            "items": {}
        },
        "title": "Knight",
        "subtitle": "Soldier of the King"
    },
    "hgHIw": {
        "key": "hgHIw",
        "isDead": false,
        "position": {
            "x": 25,
            "y": 15,
            "z": 1
        },
        "affiliation": "blue",
        "jobKey": "pirates/spear",
        "maxhealth": 30,
        "imageKey": "knight",
        "portraitKey": "knight-grunt",
        "effects": {},
        "inventory": {
            "items": {}
        },
        "title": "Knight",
        "subtitle": "Soldier of the King"
    },
    "sRH2r": {
        "key": "sRH2r",
        "isDead": false,
        "position": {
            "x": 20,
            "y": 12,
            "z": 1
        },
        "affiliation": "blue",
        "jobKey": "pirates/spearknight",
        "imageKey": "knight",
        "portraitKey": "knight-grunt",
        "effects": {},
        "inventory": {
            "items": {}
        },
        "title": "Knight",
        "subtitle": "Soldier of the King"
    },
    "mercenary": {
        "key": "mercenary",
        "isDead": false,
        "position": {
            "x": 21,
            "y": 16,
            "z": 1
        },
        "affiliation": "good",
        "effects": {},
        "inventory": {
            "items": {}
        },
        "ai": {
            "isNotCounterattacking": true
        }
    },
    "ZW2z1": {
        "key": "ZW2z1",
        "isDead": false,
        "position": {
            "x": 19,
            "y": 14,
            "z": 1
        },
        "affiliation": "blue",
        "jobKey": "pirates/spearknight",
        "imageKey": "knight",
        "portraitKey": "knight-grunt",
        "effects": {},
        "inventory": {
            "items": {}
        },
        "title": "Knight",
        "subtitle": "Soldier of the King"
    },
    "LLwTg": {
        "key": "LLwTg",
        "isDead": false,
        "position": {
            "x": 13,
            "y": 15,
            "z": 1
        },
        "affiliation": "blue",
        "jobKey": "pirates/dagger",
        "maxhealth": 20,
        "imageKey": "knight",
        "portraitKey": "knight-grunt",
        "effects": {},
        "inventory": {
            "items": {}
        },
        "title": "Knight",
        "subtitle": "Soldier of the King"
    },
    "knight": {
        "key": "knight",
        "isDead": false,
        "position": {
            "x": 11,
            "y": 14,
            "z": 1
        },
        "affiliation": "blue",
        "element": "axe",
        "moverange": "2",
        "weaponImageKey": "hammer",
        "effects": {},
        "inventory": {
            "items": {}
        }
    },
    "sBN_D": {
        "key": "sBN_D",
        "isDead": false,
        "position": {
            "x": 16,
            "y": 16,
            "z": 1
        },
        "affiliation": "blue",
        "jobKey": "pirates/hammer",
        "maxhealth": "30",
        "imageKey": "knight",
        "portraitKey": "knight-grunt",
        "effects": {},
        "inventory": {
            "items": {}
        },
        "title": "Knight",
        "subtitle": "Soldier of the King"
    },
    "lDSOD": {
        "key": "lDSOD",
        "isDead": false,
        "position": {
            "x": 17,
            "y": 12,
            "z": 1
        },
        "affiliation": "blue",
        "jobKey": "pirates/gun",
        "imageKey": "knight",
        "portraitKey": "knight-grunt",
        "effects": {},
        "inventory": {
            "items": {}
        },
        "title": "Knight",
        "subtitle": "Soldier of the King"
    },
    "mEMov": {
        "key": "mEMov",
        "isDead": false,
        "position": {
            "x": 14,
            "y": 12,
            "z": 1
        },
        "affiliation": "blue",
        "jobKey": "pirates/sword",
        "maxhealth": 30,
        "imageKey": "knight",
        "portraitKey": "knight-grunt",
        "effects": {},
        "inventory": {
            "items": {}
        },
        "title": "Knight",
        "subtitle": "Soldier of the King"
    },
    "swindler": {
        "key": "swindler",
        "isDead": false,
        "position": {
            "x": 28,
            "y": 12,
            "z": 1
        },
        "affiliation": "good",
        "effects": {},
        "inventory": {
            "items": {}
        }
    },
    "29vma": {
        "key": "29vma",
        "isDead": false,
        "position": {
            "x": 26,
            "y": 29,
            "z": 1
        },
        "affiliation": "blue",
        "jobKey": "pirates/bow",
        "maxhealth": 30,
        "imageKey": "knight",
        "portraitKey": "knight-grunt",
        "effects": {},
        "inventory": {
            "items": {}
        },
        "title": "Knight",
        "subtitle": "Soldier of the King"
    },
    "D8epo": {
        "key": "D8epo",
        "isDead": false,
        "position": {
            "x": 15,
            "y": 28,
            "z": 1
        },
        "affiliation": "blue",
        "jobKey": "pirates/hammer",
        "maxhealth": "30",
        "imageKey": "knight",
        "portraitKey": "knight-grunt",
        "effects": {},
        "inventory": {
            "items": {}
        },
        "title": "Knight",
        "subtitle": "Soldier of the King"
    },
    "E6pDM": {
        "key": "E6pDM",
        "isDead": false,
        "position": {
            "x": 16,
            "y": 29,
            "z": 1
        },
        "affiliation": "blue",
        "jobKey": "pirates/hammer",
        "maxhealth": "30",
        "imageKey": "knight",
        "portraitKey": "knight-grunt",
        "effects": {},
        "inventory": {
            "items": {}
        },
        "title": "Knight",
        "subtitle": "Soldier of the King"
    },
    "ijAjJ": {
        "key": "ijAjJ",
        "isDead": false,
        "position": {
            "x": 15,
            "y": 30,
            "z": 1
        },
        "affiliation": "blue",
        "jobKey": "pirates/hammer",
        "maxhealth": "30",
        "imageKey": "knight",
        "portraitKey": "knight-grunt",
        "effects": {},
        "inventory": {
            "items": {}
        },
        "title": "Knight",
        "subtitle": "Soldier of the King"
    }
}
